import { Injectable } from '@angular/core';

let config_key_name = "login";

@Injectable()
export class ConfigProvider {

  private config = {
    login: "",
    senha:  "",
    autoLogin: true
}
  constructor() {

  }

  // Recupera os dados do localstorage
  //localStorage.clear(); limpa
  getConfigData(): any{
      return localStorage.getItem(config_key_name);
  }
  clearStorage(){
    localStorage.clear();
  }
  // Grava os dados do localstorage
  setConfigData(login?: string,senha?: string){
    let config = {
      login: "",
      senha:"",
      autoLogin: true
  }
      if(login){
        config.login = login;
      }
      if(senha){
        config.senha = senha;
      }
   //   console.log(JSON.stringify(config))
      localStorage.setItem(config_key_name, JSON.stringify(config));
  }

}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/providers/config/config.ts